import { CountField } from '../../../fields/countField';
import { FormField } from '../../../fields/formField';
import { TextField } from '@/types/forms/fields/textField';
import { FormElement, FormElementConfig } from '../../../formElement';
import { FormGroup } from '../../../formGroup';
import { ManufacturerAndModuleTypeFormGroup } from '../manufacturerAndModuleTypeFormGroup';
import { ActivePowerAndApparentPowerFormGroup } from '../activePowerAndApparentPowerFormGroup';
import { ReferenceFormGroup } from '../../referenceFormGroup';
import { ZerezIdAndNormFormGroup } from '../zerezIdAndNormFormGroup';
import { CheckboxField } from '@/types/forms/fields/checkboxField';

export type InverterModuleFormGroupConfig = FormElementConfig &
    Omit<InverterModuleFormGroup, keyof FormGroup>;

export class InverterModuleFormGroup extends ReferenceFormGroup {
    public readonly inverterManufacturerAndModuleType: ManufacturerAndModuleTypeFormGroup;
    public readonly inverterZerezIdAndNorm: ZerezIdAndNormFormGroup;
    public readonly inverterManualInputManufacturerTypeZerezId: CheckboxField;
    public readonly unitCertificateInvalidForInstalledPower: FormElement;
    public readonly inverterQuantity: CountField;
    public readonly inverterActivePowerAndApparentPower: ActivePowerAndApparentPowerFormGroup;
    public readonly inverterTotalActivePower: FormField<number>;
    public readonly inverterTotalApparentPower: FormField<number>;

    public constructor(config: InverterModuleFormGroupConfig) {
        super(config);
        this.inverterManufacturerAndModuleType =
            config.inverterManufacturerAndModuleType;
        this.inverterZerezIdAndNorm = config.inverterZerezIdAndNorm;
        this.inverterManualInputManufacturerTypeZerezId =
            config.inverterManualInputManufacturerTypeZerezId;
        this.unitCertificateInvalidForInstalledPower =
            config.unitCertificateInvalidForInstalledPower;
        this.inverterQuantity = config.inverterQuantity;
        this.inverterActivePowerAndApparentPower =
            config.inverterActivePowerAndApparentPower;
        this.inverterTotalActivePower = config.inverterTotalActivePower;
        this.inverterTotalApparentPower = config.inverterTotalApparentPower;
    }
}
